module.exports = __webpack_public_path__ + "static/media/foto_video.45f0d530.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wish-list/foto_video.jpg
// module id = 1067
// module chunks = 0